import React, { useEffect, useMemo, useRef, useState } from "react"
import { FixedSizeList } from "react-window"
import { MdAppShortcut, MdWhatsapp } from "react-icons/md"
import { ImageRounded } from "../ImageRounded"
import { CheckBox } from "../Form"
import { AvatarIcon } from "../Avatar"
import { ImBlocked } from "react-icons/im"
import { useMediaQuery } from "react-responsive"
import { Button } from "antd"
import { AutoSizer, CellMeasurer, CellMeasurerCache, List } from "react-virtualized"
import "./styles.scss"
import moment from "moment"
import { useNavigate } from "react-router-dom"
import { isMobile } from "react-device-detect"
import ModalAlert from "../ModalAlert"
import { LoadingWithLabel } from "../Loading"

export const ActionPlanList = ({ data, loading, className }) => {
  const ref = useRef(null)

  const cache = useMemo(() => {
    return new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 350,
    })
  }, [data])

  const Row = ({ index, key, parent, style }) => {
    const row = data[index]

    return (
      <>
        <CellMeasurer cache={cache} columnIndex={0} key={key} rowIndex={index} parent={parent}>
          <div style={{ ...style }} className={`row-style`}>
            <div className="action-plan__list">
              {row.indicator && (
                <div className="action-plan__list-indicator">
                  <div className="indicator-header">
                    <span className="indicator-header__badge">sdsd</span>
                    <div className="indicator-header__title">{row.indicator.title}</div>
                  </div>
                  <Button label="Concluir" variant="outline" />
                </div>
              )}
              <div className="action-plan__list-container">
                <div className="action-plan__list-container-header">
                  <span className="action-plan__list-container-header__title">{row.title}</span>
                  <span className="action-plan__list-container-header__end">
                    <span className="info">Termina em: </span>
                    <span className="date">{row?.endDate}</span>
                  </span>
                </div>
                <div className="action-plan__list-container-content">
                  <div className="content-block5w2h">
                    <span className="content-block5w2h__title">Onde será realizada a ação</span>
                    <p className="content-block5w2h__info">{row.details.location}</p>
                  </div>
                  <div className="content-block5w2h">
                    <span className="content-block5w2h__title">Como será realizada a ação?</span>
                    <p className="content-block5w2h__info">{row.details.instructions}</p>
                  </div>
                  <div className="content-block5w2h">
                    <span className="content-block5w2h__title">Porque realizará a ação?</span>
                    <p className="content-block5w2h__info">{row.details.why}</p>
                  </div>
                  <div className="content-block5w2h">
                    <span className="content-block5w2h__title">Responsável</span>
                    <p className="content-block5w2h__info">{row.details.who}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CellMeasurer>
      </>
    )
  }

  const medium = useMediaQuery({ query: "(max-width:1366px)" })

  return (
    <div className={`list-view-plan-action${className ? ` ${className}` : ""}`}>
      <AutoSizer className="plan-action-scroller">
        {({ height, width }) => (
          <>
            {loading ? (
              <div className="loading-content" style={{ height, width }}>
                <Spinner color="primary" />
              </div>
            ) : data.length > 0 ? (
              <>
                <List
                  ref={ref}
                  //autoHeight
                  deferredMeasurementCache={cache}
                  height={height}
                  rowCount={data?.length}
                  rowHeight={cache.rowHeight}
                  rowRenderer={Row}
                  width={width - 32}
                  innerElementType="ul"
                  c
                  className="list-view-plan-action-scroll"></List>
              </>
            ) : (
              <div className="channels-empty" style={{ height, width }}>
                <h3>Não há chats</h3>
              </div>
            )}
          </>
        )}
      </AutoSizer>
    </div>
  )
}

export const FormsList = ({ data, handleClick, isModal }) => {
  const element = useRef(null)

  const HD = useMediaQuery({ query: "(min-width:1280px) and (max-width:1366px)" })

  const Row = ({ index, style, data, handleClick }) => {
    const row = data[index]

    const completedFormDate =
      row && row?.completedFormDate && moment(row?.completedFormDate).format("DD/MM/YYYY")

    return isMobile ? (
      <div>
        <div className="list-view-forms list-view-forms-mobile">
          <div className="list-view-forms-item" onClick={() => handleClick(row)}>
            <i className="fi fi-sr-list" />
            <div className={`item-progress${completedFormDate ? " filled" : ""}`}>
              <span className="item-progress-title" title={row?.title}>
                {row?.title}
              </span>
              {completedFormDate && (
                <div className="form-filled" title={`Última atualização: ${completedFormDate}`}>
                  <span className="form-filled-indicator">Última atualização:</span>
                  <span className="form-filled-indicator-date">{completedFormDate}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div style={style}>
        <div className="list-view-forms">
          <div className="list-view-forms-item" onClick={() => handleClick(row)}>
            <i className="fi fi-sr-list" />
            <div className={`item-progress${completedFormDate ? " filled" : ""}`}>
              <span className="item-progress-title" title={row?.title}>
                {row?.title}
              </span>
              {completedFormDate && (
                <div className="form-filled" title={`Última atualização: ${completedFormDate}`}>
                  <span className="form-filled-indicator">Última atualização:</span>
                  <span className="form-filled-indicator-date">{completedFormDate}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <AutoSizer className="scrollable">
        {({ height, width }) => (
          <FixedSizeList
            height={isModal ? 500 : height}
            itemCount={data?.length}
            itemSize={HD ? 45 : 55}
            width={width}
            outerRef={element}
            className={isModal ? "list-view-forms__container" : ""}>
            {({ index, style }) => (
              <Row index={index} style={style} data={data} handleClick={handleClick} />
            )}
          </FixedSizeList>
        )}
      </AutoSizer>
    </>
  )
}

export const ListView = ({
  data,
  handleClick,
  defaultImage,
  hideScroll,
  className,
  checked,
  setChecked,
  changeOptions,
  changeCheckAll,
  height,
  checkedDisable = false,
}) => {
  const Row = ({ index, style }) => {
    const row = data[index]
    return (
      <>
        {row && (
          <div style={style}>
            <div
              className={`list-view__item${className ? " " + className : ""}`}
              onClick={() => handleClick && handleClick(row?.value)}>
              {row.image && (
                <div className="list-view__item-icon">
                  <ImageRounded icon={row.image || defaultImage} />
                </div>
              )}
              {row?.checkbox && (
                <input
                  name={row?.value}
                  value={row?.value}
                  type="checkbox"
                  checked={checked?.some((val) => val === row?.value)}
                  className="list-view__item-check"
                  onChange={changeOptions}
                  disabled={checkedDisable}
                />
              )}
              <a href={`https://manejechat.com.br/community/${row?.value}`} target="_blank">
                {row?.label}
              </a>
              {row?.component && row?.component}
            </div>
          </div>
        )}
      </>
    )
  }

  return (
    <>
      <div className={`list-view${className ? " " + className : ""}`}>
        {data && (
          <>
            {checked && (
              <div className="list-view-check">
                <CheckBox
                  onChange={(event) => changeCheckAll(false, event.target.value)}
                  value={checked?.length === data?.length ? false : true}
                  checked={checked?.length === data?.length && data?.length !== 0}
                  disabled={checkedDisable}
                />
                <span>{isMobile ? "Selecionar todos" : `Todos (${data.length})`}</span>
              </div>
            )}

            <AutoSizer className="list-view-scrollable">
              {({ height, width }) => (
                <FixedSizeList
                  height={height || 600}
                  itemCount={data.length}
                  itemSize={50}
                  width={"100%"}
                  itemData={data}
                  innerElementType="div"
                  className={hideScroll ? "list-view-hide-scroll" : "list-view-scroll-style"}>
                  {Row}
                </FixedSizeList>
              )}
            </AutoSizer>
          </>
        )}
      </div>
    </>
  )
}

const AssistanceAvatar = ({
  direction = "column",
  showSubtitle = true,
  isVerticallList = false,
  size = 40,
  row,
  listAssistanceData,
}) => {
  let name =
    listAssistanceData && listAssistanceData?.userNames[0]
      ? listAssistanceData?.userNames[0]?.name
      : row?.userNames[0]
        ? row?.userNames[0]?.name
        : "Produtor"

  return (
    <div
      className={`assistance-avatar ${isVerticallList ? "vertical" : "horizontal"}`}
      style={{ flexDirection: direction, gap: direction === "row" ? "16px" : "" }}>
      <AvatarIcon size={size} name={name} backgroundColor="random" />
      <div className="assistance-avatar-content">
        <div
          className="assistance-avatar-content-details"
          style={{ alignItems: direction === "row" ? "baseline" : "center" }}>
          <span className={`assistance-avatar-content-details-name`}>{name}</span>
          <span className="assistance-avatar-content-details-title">
            {isVerticallList ? listAssistanceData && listAssistanceData?.title : row && row?.title}
          </span>
        </div>
        {showSubtitle && (
          <div className="assistance-avatar-content-subtitle">
            {row && moment.utc(row?.createdAt).format("DD MMM")}
          </div>
        )}
      </div>
    </div>
  )
}

export const AssistanceToResolveList = ({ data, handleClick, className, appointmentsData, loadingAppointments = false }) => {
  let scrollRef = useRef(null)
  const [scrollX, setScrollX] = useState(0)
  const [scrollEnd, setScrollEnd] = useState(false)

  const slideScroll = (shift) => {
    scrollRef.current.scrollBy({
      left: shift,
      behavior: "smooth",
    })

    scrollRef.current.scrollLeft += shift
    setScrollX(scrollX + shift)
    if (
      Math.floor(scrollRef.current.scrollWidth - scrollRef.current.scrollLeft) <=
      scrollRef.current.offsetWidth
    ) {
      setScrollEnd(true)
    } else {
      setScrollEnd(false)
    }
  }

  const onScroll = () => {
    setScrollX(scrollRef.current.scrollLeft)
    if (
      Math.floor(scrollRef.current.scrollWidth - scrollRef.current.scrollLeft) <=
      scrollRef.current.offsetWidth
    ) {
      setScrollEnd(true)
    } else {
      setScrollEnd(false)
    }
  }

  const HD = useMediaQuery({ query: "(min-width:1280px) and (max-width:1366px)" })
  const FULLHD = useMediaQuery({ query: "(min-width:1367px) and (max-width:1920px)" })

  const itemSize = 220

  const Column = ({ index, style, handleClick, itemSize }) => {
    const row = appointmentsData && appointmentsData[index]

    return (
      <div style={style}>
        <div className="next-assistance-list-view__container" onClick={() => handleClick(row)}>
          <div
            className="next-assistance-list-view-content"
            style={{
              width: itemSize,
            }}>
            <div className="next-assistance-list-view-content-item">
              <AssistanceAvatar size={HD ? 40 : 48} row={row} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  if (loadingAppointments) {
    return (
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: HD ? 168 : FULLHD ? 188 : 200,
        }}>
        <LoadingWithLabel labelLoading="Buscando agendamentos..." colorSpinner="primary" />
      </div>
    )
  }

  return (
    <>
      {appointmentsData?.length > 0 ? (
        <div className="scrollable-list">
          <button
            className={`left ${scrollX < 1 ? "is-disabled-hide" : ""}`}
            onClick={() => slideScroll(-100)}>
            <i className="fi fi-rr-angle-small-left"></i>
          </button>
          <FixedSizeList
            height={HD ? 168 : FULLHD ? 188 : 200}
            itemCount={appointmentsData?.length}
            itemSize={itemSize}
            layout="horizontal"
            width={3000}
            outerRef={scrollRef}
            onScroll={onScroll}
            className="assistance-list-scroll">
            {({ index, style }) => (
              <Column
                index={index}
                style={style}
                data={data}
                handleClick={handleClick}
                itemSize={itemSize}
              />
            )}
          </FixedSizeList>
          <button
            className={`right ${!scrollEnd ? "" : "is-disabled-hide"}`}
            onClick={() => slideScroll(+100)}>
            <i className="fi fi-rr-angle-small-right"></i>
          </button>
        </div>
      ) : (
        <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", height: HD ? 168 : FULLHD ? 188 : 200 }}>
          <h3 className="empty-text-list">Não há agendamentos</h3>
        </div>
      )}
    </>
  )
}

export const AssistanceList = ({
  handleClick,
  onChangeSelectedId,
  selectedId,
  listData
}) => {
  const element = useRef(null)
  const HD = useMediaQuery({ query: "(min-width:1280px) and (max-width:1366px)" })

  const Column = ({ index, style }) => {
    const listAssistanceData = listData?.[index]
    const userId = listAssistanceData?.userIds?.[0]
    const rowId = listAssistanceData?.id

    const isSelected = selectedId?.userId === userId && selectedId?.rowId === rowId
    const isFrozen = selectedId !== null && !isSelected

    return (
      <div style={style}>
        <div className={`open-closed-assistance-list-view__container ${isFrozen ? "frozen" : ""}`}>
          <div className="open-closed-assistance-list-view-content">
            <div className="open-closed-assistance-list-view-content-item">
              <div className="checkbox-wrapper">
                <div className="checkbox-visibility visible">
                  <CheckBox
                    checked={isSelected}
                    onChange={() =>
                      onChangeSelectedId?.(isSelected ? null : { ...listAssistanceData, userId, id: userId, rowId })
                    }
                    disabled={isFrozen}
                  />
                </div>
              </div>

              <div className="avatar-date">
                <AssistanceAvatar
                  direction="row"
                  showSubtitle={false}
                  isVerticallList
                  size={HD ? 40 : 48}
                  listAssistanceData={listAssistanceData}
                />
                <div className="date">
                  <span>
                    {listAssistanceData &&
                      moment(listAssistanceData?.dateToAdd).format("DD/MM/YYYY")}
                  </span>
                </div>
              </div>

              <button
                className={`btn ${isSelected ? `frozen` : ``}`}
                onClick={() => handleClick(listAssistanceData)}
                disabled={isFrozen}
              >
                <i className="fi fi-rr-angle-small-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const itemSize = HD ? 70 : 100
  const rowSize = HD ? 40 : 70

  return (
    <AutoSizer className="open-closed-assistance-list-view-scrollable">
      {({ height, width }) => (
        <FixedSizeList
          height={height - rowSize}
          itemCount={listData?.length}
          itemSize={itemSize}
          width={width}
          outerRef={element}
          className="assistance-list-scroll"
        >
          {({ index, style }) => (
            <Column
              index={index}
              style={style}
            />
          )}
        </FixedSizeList>
      )}
    </AutoSizer>
  )
}

export const ListViewMessageSend = ({
  data,
  hideScroll,
  className,
  hasErrorColumn = false,
  onCheckedChange,
  checked,
  countMessageFailed = false,
  countMessageSend = false,
}) => {
  const Row = ({ index, style }) => {
    const row = data[index]

    return (
      <>
        {row && (
          <div style={style}>
            <li className={`list-view-message-send__item${className ? " " + className : ""}`}>
              {typeof onCheckedChange === "function" && (
                <CheckBox
                  onChange={(event) => onCheckedChange(row, event.target.value)}
                  value={row.isChecked ? false : true}
                  checked={row.isChecked}
                />
              )}
              <div className="list-view-message-send__item-info" title={row?.name}>
                <AvatarIcon size="32" icon={row.image} name={row?.name} />
                <span>{row?.name}</span>
              </div>
              <span className="shipping-method">
                {row.shipping === "whatsapp" ? (
                  <>
                    <MdWhatsapp title="Whatsapp" />
                  </>
                ) : row.shipping === "Sem Whatsapp" ? (
                  <>
                    <ImBlocked title="Sem Whatsapp" />
                  </>
                ) : (
                  <>
                    <MdAppShortcut title="Manejechat" />
                  </>
                )}
                {row.link && <span>{row?.link}</span>}
              </span>
              {row?.component && row?.component}
              {row?.project}
              {/* {(row?.lastMessage && !hasErrorColumn) && <span className="integration-message" title={row?.lastMessage}>{row.lastMessage || ''}</span>} */}
              {hasErrorColumn && !row?.lastMessage && (
                <span className="error-message" title={row?.errorMessage}>
                  {row.errorMessage || ""}
                </span>
              )}
            </li>
          </div>
        )}
      </>
    )
  }

  const M = useMediaQuery({ query: "(max-height:768px)" })

  return (
    <>
      <div className={`list-view-message-send${className ? " " + className : ""}`}>
        {data && (
          <>
            {!countMessageFailed && !countMessageSend && (
              <div className="modal-message-feedback modal-message-feedback--checkbox  withErrorColumn">
                <CheckBox
                  onChange={(event) => onCheckedChange(data, event.target.value)}
                  value={Array.isArray(checked) && checked.length === data.length ? false : true}
                  checked={
                    Array.isArray(checked) && checked.length === data.length && data.length !== 0
                  }
                />
                <span>Todos</span>
                <span>Usuário</span>
                <span>Meio</span>
                <span>Projeto</span>
                {/* <span>Última Integração</span> */}
              </div>
            )}
            {countMessageFailed && (
              <div className="modal-message-feedback withErrorColumn">
                <span>Usuário</span>
                <span>Meio</span>
                <span>Erro</span>
              </div>
            )}
            {countMessageSend && (
              <div className="modal-message-feedback">
                <span>Quem recebeu</span>
                <span>Meio</span>
              </div>
            )}
            <FixedSizeList
              height={M ? 400 : 578}
              itemCount={data.length}
              itemSize={50}
              width={M ? "104%" : "103%"}
              itemData={data}
              innerElementType="ul"
              className={hideScroll ? "list-view-hide-scroll" : "list-view-scroll-style-user"}>
              {Row}
            </FixedSizeList>
          </>
        )}
      </div>
    </>
  )
}

export const ListViewTemplates = ({
  data,
  handleClick,
  hideScroll,
  className,
  selectedTemplate,
  handleDelete,
}) => {
  const Row = ({ index, style }) => {
    const row = data[index]
    return (
      <>
        {row && (
          <div key={row?.id} style={style}>
            <div
              className={`list-view-template__item${className ? " " + className : ""}${selectedTemplate?.id === row?.id ? " selected-template" : ""
                }`}
              onMouseUp={() => handleClick && handleClick(row)}>
              <div className="row-template-title">
                <h6 className="template-title" title={row?.title}>
                  {row?.title}
                </h6>
                {handleDelete && (
                  <button
                    onMouseUp={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      ModalAlert.warn({
                        title: "Deseja continuar ?",
                        text: "Deseja excluir este template ?",
                        confirmLabel: "Excluir",
                        onConfirm: () => handleDelete(row?.id),
                      })
                    }}>
                    <i className="fi fi-rr-trash"></i>
                  </button>
                )}
              </div>
              <p title={row?.message}>{row?.message}</p>
            </div>
          </div>
        )}
      </>
    )
  }

  const T = useMediaQuery({ query: "(max-height:768px)" })
  const D = useMediaQuery({ query: "(max-height:900px)" })

  return (
    <>
      <div className={`list-view-template${className ? " " + className : ""}`}>
        {data && (
          <>
            <FixedSizeList
              height={T ? 280 : D ? 360 : 450}
              itemCount={data.length}
              itemSize={120}
              width={"100%"}
              itemData={data}
              className={hideScroll ? "list-view-hide-scroll" : "list-view-scroll-style"}
              itemKey={(index, data) => data[index]?.id || index}>
              {Row}
            </FixedSizeList>
          </>
        )}
      </div>
    </>
  )
}

export const ListViewUser = ({
  data,
  defaultImage,
  hideScroll,
  className,
  height,
  hasErrorColumn = false,
  onCheckedChange,
  checked,
  hasChecked = true,
  countMessageFailed = false,
  countMessageSend = false,
}) => {
  const Row = ({ index, style }) => {
    const row = data[index]
    return (
      <>
        {row && (
          <div style={style}>
            <li className={`list-view-user__item${className ? ` ${className}` : ""}`}>
              {hasChecked && (
                <CheckBox
                  onClick={() => console.log("AAAA")}
                  onChange={(event) => onCheckedChange(row, event.target.value)}
                  value={!row.isChecked}
                  checked={row.isChecked}
                />
              )}
              <div className="list-view-user__item-info" title={row?.name}>
                <AvatarIcon size="32" icon={row.image} name={row?.name} />
                <span>{row?.name}</span>
              </div>
              {row?.component && row?.component}
              {hasErrorColumn && !row?.lastMessage && (
                <span className="error-message" title={row?.errorMessage}>
                  {row.errorMessage || ""}
                </span>
              )}
            </li>
          </div>
        )}
      </>
    )
  }

  const M = useMediaQuery({ query: "(max-height:768px)" })

  return (
    <div className={`list-view-user${className ? ` ${className}` : ""}`}>
      {data && (
        <>
          {hasChecked && (
            <div className="list-view-user-feedback list-view-user-feedback--checkbox">
              <CheckBox
                onChange={(event) => onCheckedChange(data, event.target.value)}
                value={Array.isArray(checked) && checked.length === data.length}
                checked={
                  Array.isArray(checked) && checked.length === data.length && data.length !== 0
                }
              />
              <span>Todos</span>
              <span>Usuário</span>
            </div>
          )}
          {countMessageFailed && (
            <div className="list-view-user-feedback">
              <span>Usuário</span>
            </div>
          )}
          {countMessageSend && (
            <div className="list-view-user-feedback">
              <span>Quem recebeu</span>
            </div>
          )}

          <AutoSizer className="scrollable">
            {({ height, width }) => (
              <FixedSizeList
                height={M ? 365 : 565}
                itemCount={data.length}
                itemSize={50}
                width={width || M ? "104%" : "103%"}
                itemData={data}
                innerElementType="ul"
                className={hideScroll ? "list-view-hide-scroll" : "list-view-scroll-style-user"}>
                {Row}
              </FixedSizeList>
            )}
          </AutoSizer>
        </>
      )}
    </div>
  )
}
